import { call, put } from 'redux-saga/effects';
import moment from 'moment';
import processError from '../../../utils/processError';
import { setGPSData, wsConnectionFailed, wsConnectionSuccessful } from '../actions';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { WS_URL } from '../../../configs';
import { getJSONFromString } from '../../../utils/utils';

window.wsConnection = null;
export default function* wsConnection(action) {
  const { dispatch } = window.appStore;
  try {
    if (!window.wsConnection) {
      window.wsConnection = new WebSocket(WS_URL);
      window.wsConnection.onopen = function () {
        dispatch(wsConnectionSuccessful());
      };

      window.wsConnection.onmessage = function (event) {
        const data = getJSONFromString(event.data) || {};
        dispatch(setGPSData(data));
        if (data && data.data && data.data.global_time) {
          const currentDate = new Date();
          const initialM = moment(data.data.global_time);
          if (initialM && initialM.isValid()) {
            const initialDate = initialM.toDate();
            window.serverTimeOffset = initialDate.getTime() - currentDate.getTime();
          }
        }
        // dispatch(wsConnectionOnMessage(event.data));
      };

      window.wsConnection.onclose = function (event) {
        dispatch(wsConnectionFailed());
      };

      window.wsConnection.onerror = function (error) {
        console.error(error);
        dispatch(wsConnectionFailed());
      };
    }
  } catch (e) {
    yield put(wsConnectionFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
